import { Redirect, Route, Switch } from 'react-router-dom';
import { EVENTS_ROOT } from 'src/redesign/shared/routes';
import { EventRouter } from 'src/redesign/router';
import { SiteWrapper } from 'src/app';
import React, { Suspense } from 'react';
import { Loader } from 'src/redesign/components/Loader';
import { SiteRouter } from 'src/features/SiteRouter';
import { AttendeeEventsPage } from 'src/redesign/pages/AttendeeEventsPage';

const AttendeeTicketPage = React.lazy(() =>
  import('src/modules/tickets').then((module) => ({ default: module.AttendeeTickets }))
);

const WixWidgetsPage = React.lazy(() =>
  import('src/modules/sites/wix-widgets').then((module) => ({ default: module.WixWidgets }))
);

const WixPricingPage = React.lazy(() =>
  import('src/modules/sites/wix-pricing').then((module) => ({ default: module.WixPricing }))
);

const AdvancedEmailEditorPage = React.lazy(() =>
  import('src/modules/campaigns/advanced-email-editor').then((module) => ({
    default: module.AdvancedEmailEditor,
  }))
);
const WixLoginProxyPage = React.lazy(() =>
  import('src/modules/login/wix-login-proxy').then((module) => ({
    default: module.WixLoginProxy,
  }))
);

export const AuthRouter = () => {
  return (
    <Switch>
      <Route exact path="/auth/wix-login-proxy" component={WixLoginProxyPage} />
      <Route exact path="/" component={() => <Redirect to={EVENTS_ROOT} />} />
      <Route
        exact
        path="/my-tickets"
        component={() => (
          <Suspense fallback={<Loader />}>
            <AttendeeTicketPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/wix-widgets"
        component={() => (
          <Suspense fallback={<Loader />}>
            <WixWidgetsPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/wix/pricing"
        component={() => (
          <Suspense fallback={<Loader />}>
            <WixPricingPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path={`/campaigns/email-editor/:id`}
        render={(props) => (
          <Suspense fallback={<Loader />}>
            <SiteWrapper {...props} noAuth>
              <AdvancedEmailEditorPage />
            </SiteWrapper>
          </Suspense>
        )}
      />
      <Route path="/sites">
        <SiteRouter />
      </Route>
      <Route path={EVENTS_ROOT}>
        <EventRouter />
      </Route>
      <Route path="/attendee-dashboard">
        <AttendeeEventsPage />
      </Route>
    </Switch>
  );
};
